import customSelect from './functions/customSelect';
import {
	closeMobileMenuOnClickOutside,
	closeMobileMenuOnResize,
	toggleMobileMenu,
} from './navigation/toggleMobileMenu';

/* global __theme_scripts */

( ( $ ) => {

	/**
	 * Assign events handlers
	 *
	 * @private
	 */
	const __assign = () => {
		$( '.menu-toggle' ).on( 'click', toggleMobileMenu );
		$( document.body )
			.on( 'click', event => {
				closeMobileMenuOnClickOutside( event );
			} )
		$( window )
			.on( 'resize', event => {
				closeMobileMenuOnResize( event );
			} );
	};


	/**
	 * Initialize
	 *
	 * @private
	 */
	function __init() {
		console.info( '[theme] Theme JS initiated!' );
		customSelect();
		__assign();
	}

	return {
		/**
		 * Call to init ourselves
		 */
		init: function() {
			if ( document.readyState === 'complete' ) {
				__init();
			} else {
				window.addEventListener( 'load', function() {
					__init();
				} );
			}
		},
	};
} )( jQuery.noConflict() ).init();
